import { render } from "./Completed_course_summary.vue?vue&type=template&id=66dbb296&ts=true"
import script from "./Completed_course_summary.vue?vue&type=script&lang=ts"
export * from "./Completed_course_summary.vue?vue&type=script&lang=ts"

import "./Completed_course_summary.vue?vue&type=style&index=0&id=66dbb296&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__